import styled from 'styled-components';

export const StyledButton = styled.button`
  border: none;
  border-bottom: 1px solid #e9e9ea;
  background: transparent;
  width: 100%;
  font-size: 1.125rem;
  font-family: ${Styles.fontFamily.base};
  text-transform: uppercase;
  padding: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: ${Styles.color.grey.one};
  cursor: pointer;

  &[disabled] {
    color: ${Styles.color.grey.three};
    cursor: not-allowed;

    svg {
      fill: ${Styles.color.grey.three};
    }
  }
`;
